import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { OtpDataForm } from '../_models/otp-data-form';
import { ActivatedRoute, Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../_services/auth.service';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { OtpService } from '../_services/otp.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  title = 'Forgot Password';
  forgotPasswordForm: FormGroup;
  emailId: string;
  model: any = {};
  userName: string;
  sentOtpFlag = '';


  otpDataForm = new OtpDataForm();

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    public snotifyService: SnotifyService,
    public formBuilder: FormBuilder,
    public authService: AuthService,
    public otpService: OtpService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.userName = params['userName'];
      this.sentOtpFlag = 'true';
    });
  }

  ngOnInit() {
    this.createFPForm();
    if (this.sentOtpFlag == 'true' && this.userName != null) {
      this.otpDataForm.userName = this.userName;
    }
  }

  public cancelForgotPassword() {
    this.router.navigate(['/login']);
  }

  createFPForm() {
    this.forgotPasswordForm = this.formBuilder.group({
      'emailId': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(45),
          Validators.required])
      ]),

      'otp': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(15),
          Validators.required])
      ]),

      'newPassWord': new FormControl('', [
        Validators.compose([
          Validators.minLength(3),
          Validators.maxLength(15),
          Validators.required])
      ])
    });
  }

  getErrorMsgForforgotPasswordEmailForm() {
    return this.forgotPasswordForm.controls.emailId.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      this.forgotPasswordForm.controls.emailId.errors.minlength ? ValidationErrorMessageEnum.MIN_LENGTH_THREE :
        this.forgotPasswordForm.controls.emailId.errors.email ? ValidationErrorMessageEnum.VALID_EMAIL :
          this.forgotPasswordForm.controls.emailId.errors.maxlength ? ValidationErrorMessageEnum.MAX_LENGTH_FORTY_FIVE :
            '';
  }

  public forgotPassword(forgotPasswordForm) {
    this.forgotPasswordForm.controls['emailId'].markAsTouched();
  }


}
